/**
 * Iter-59 — Small contextual "?" link into a specific Help article.
 *
 * Renders a discreet inline "Learn how" chip. Non-invasive — does not
 * change layout or behaviour of the parent page.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Question } from "@phosphor-icons/react";

export default function HelpLink({ slug, label = "Learn how", testId }) {
  return (
    <Link
      to={`/help?slug=${encodeURIComponent(slug)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest border border-black px-1.5 py-0.5 bg-white hover:bg-yellow-50 text-zinc-700"
      data-testid={testId || `help-link-${slug}`}
    >
      <Question size={12} weight="bold" />
      {label}
    </Link>
  );
}
